export const Config = {
    apiKey: process.env.REACT_APP_EDITOR_API_KEY,
    url: process.env.REACT_APP_BASE_URL   ,
    urlV2: process.env.REACT_APP_BASE_URL_V2,
    urlLogin: process.env.REACT_APP_BASE_URL_LOGIN  ,
    publicKey: process.env.REACT_APP_PAYMENT_PUBLIC_KEY  ,
    logs_url: process.env.REACT_APP_BASE_URL_LOGS
} 